import ApiService from '../api.service'

export default class ArticleService extends ApiService {
  constructor () {
    super()
    this.path = 'article.php'
  }

  articleList (params) {
    const path = `${this.path}`
    return this.http.get(path, {params})
  }

  deleteArticles(params) {
    const path = `${this.path}?act=delA`
    return this.http.delete(path, params)
  }

  saveArticles (params) {
    const path = `59/wxeditor/${this.path}/save`
    return this.http.put(path, params)
  }

  lookArticle(params) {
    const path = `article_detail.php`
    return this.http.get(path, {params})
  }
  importArticle (params) {
    const path = `article_coll.php`
    return this.http.get(path, {params})
  }
  
}



// WEBPACK FOOTER //
// ./src/service/api/articleService.js